import {axios} from "~/plugins/axios";

const getDefaultState_Tariffications = () => {
  return {
    report: [],
    tariff: {},
  }
}
const state = getDefaultState_Tariffications();

const getters = {
  tarifficationReport: state => state.report,
  tariff: state => state.tariff,
}

const actions = {
  async loadTarifficationsReport({commit}, payload) {
    commit('shared/SET_LOADING', true, {root: true});

    await axios.get('/api/reports/tariffication/tariffs', {params: payload})
      .then(response => {
        if (payload['tariff_id'] !== undefined) {
          if (response.data.data.length === 1) {
            commit('SET_TARIFF', response.data.data[0]);
          }
        } else {
          commit('SET_REPORT', response.data.data);
        }

      }).catch(error => {
        console.error(error);
      })

    commit('shared/SET_LOADING', false, {root: true})
  },
}

const mutations = {
  SET_REPORT(state, data) {
    state.report = data;
  },

  SET_TARIFF(state, data) {
    state.tariff = data;
  },

  RESET_STATE_TARIFFICATIONS (state) {
    Object.assign(state, getDefaultState_Tariffications())
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
